import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to top on pathname changes.
// Language switches only change the first URL segment while the sub-path remains the same,
// so we detect "language-only" transitions and DO NOT scroll in that case.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Determine if the change is a language-only switch by comparing everything after the first segment.
    // Store previous pathname on window.
    const prev = window.__prevPathname || "";
    window.__prevPathname = pathname;

    if (prev) {
      const prevParts = prev.split("/").filter(Boolean);
      const nextParts = pathname.split("/").filter(Boolean);

      const prevLang = prevParts[0];
      const nextLang = nextParts[0];

      const prevRest = prevParts.slice(1).join("/");
      const nextRest = nextParts.slice(1).join("/");

      const isLanguageOnlySwitch =
        ["hr", "en"].includes(prevLang) &&
        ["hr", "en"].includes(nextLang) &&
        prevLang !== nextLang &&
        prevRest === nextRest;

      if (isLanguageOnlySwitch) return;
    }

    // Skip smooth scroll for hash targets — browser handles those
    if (window.location.hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return null;
}
